import { faSave } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';

// Renomeado para maior clareza
const TemplateDaysToCompleteEditModal = ({
  show,
  close,
  taskData,
  setTaskData
}) => {
  const [days, setDays] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (show && taskData) {
      // Garantir que valores undefined sejam tratados como null
      const value = taskData.days_to_complete;
      setDays(value === undefined || value === null ? null : value);
    }
  }, [show, taskData]);

  const handleSave = async () => {
    if (!taskData) return;

    setIsLoading(true);
    try {
      // Simula delay da API
      await new Promise(resolve => setTimeout(resolve, 200));

      // Atualiza os dados da tarefa
      const updatedTaskData = {
        ...taskData,
        days_to_complete: days === 'null' || days === null ? null : days
      };

      setTaskData(updatedTaskData);
      close();
    } catch (error) {
      console.error('Erro ao salvar duração:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      handleSave();
    } else if (e.key === 'Escape') {
      close();
    }
  };

  return (
    <Modal show={show} onHide={close} size="md" onKeyDown={handleKeyDown}>
      <Modal.Header closeButton>
        <Modal.Title>Definir Duração</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group controlId="days_to_complete">
            <Form.Label>Duração em dias</Form.Label>
            <Form.Select
              value={days === null ? 'null' : days}
              onChange={e => {
                const value = e.target.value;
                if (value === 'null') setDays(null);
                else setDays(Number(value));
              }}
              autoFocus
            >
              <option value="null">Sem prazo</option>
              <option value={0}>0 (Data de criação do ticket)</option>
              {[...Array(366).keys()].slice(1).map(i => (
                <option key={i} value={i}>
                  {i} dia{i > 1 ? 's' : ''}
                </option>
              ))}
            </Form.Select>
            <Form.Text className="text-muted">
              Defina quantos dias são necessários para concluir esta tarefa
            </Form.Text>
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="falcon-default" onClick={close} disabled={isLoading}>
          Cancelar
        </Button>
        <Button onClick={handleSave} disabled={isLoading}>
          {isLoading ? 'Salvando...' : 'Salvar'}
          <FontAwesomeIcon icon={faSave} className="ms-2" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TemplateDaysToCompleteEditModal;
